import React, { useContext, useState } from "react"
import { useForm } from "react-hook-form"
import { ScrollView, View } from "react-native"
import { connect } from "react-redux"
import FilledButtonM from "../common/components/button/FilledButtonM"
import TextInputM from "../common/components/input/TextInputM"
import { ModalM } from "../common/components/modal/ModalM"
import TextM from "../common/components/text/TextM"
import { useApiStatus } from "../common/hooks/useApiStatus"
import { theme } from "../common/theme/theme"
import { DimensionsContext, IS_WEB } from "../common/utils/mobileUtils"
import {
    apiIdle,
    apiRequest,
    apiRequestWithPrerequest,
} from "../data/redux/actions/api"
import { schoolCardReportService } from "../data/services/schoolCardReportService"
import { ChampionImageM } from "../student/champions/ChampionImageM"

function EnterEmailModal(props) {
    const { modalVisible, setModalVisible } = props
    const [emailSubmitted, setEmailSubmitted] = useState(false)
    const [hasError, setHasError] = useState(false)
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues: {
            email: "",
        },
    })

    const dimensions = useContext(DimensionsContext)

    const width =
        dimensions.width > 800
            ? dimensions.width / 2.2
            : dimensions.width - 20

    const onSubmit = (data) => {
        props.apiRequestWithPrerequest(
            schoolCardReportService.updateReportEmailByHash,
            {},
            { email: data.email, hash: props.hash }
        )
    }

    useApiStatus(
        schoolCardReportService.updateReportEmailByHash,
        null,
        false,
        () => {
            setEmailSubmitted(true)
        },
        () => {
            setHasError(true)
        }
    )

    const openExternalLink = async () => {
        const url = "https://masteur.com/home?ref=GMXd9pobxW"

        if (IS_WEB) {
            window.location.href = url
        } else {
            const canOpen = await Linking.canOpenURL(url)
            if (canOpen) {
                await Linking.openURL(url)
            } else {
                console.error("Cannot open URL: " + url)
            }
        }
    }

    const successContent = (
        <View
            style={{
                width,
                marginBottom: 20,
                paddingHorizontal: 20,
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <TextM
                fontSize={32}
                fontWeight="ExtraBold"
                color={theme.colors.primary}
                style={{
                    textAlign: "center",
                    marginBottom: 20,
                }}
                wrap
            >
                Merci !
            </TextM>

            <ChampionImageM name="sam" variant="happy" width={190} />

            <TextM
                fontSize={20}
                fontWeight="Bold"
                color={theme.colors.primary}
                style={{
                    marginTop: 30,
                    marginBottom: 10,
                    textAlign: "center",
                }}
                wrap
            >
                Vous allez recevoir votre bilan par email dans quelques instants
            </TextM>

            <TextM
                fontSize={16}
                fontWeight="regular"
                color={theme.colors.primary}
                style={{
                    marginBottom: 20,
                    textAlign: "center",
                }}
                wrap
            >
                {
                    "N'oubliez pas de vérifier vos spams si vous ne le recevez pas."
                }
            </TextM>

            <FilledButtonM
                style={{
                    width: "100%",
                }}
                onPress={openExternalLink}
                trackingId="school_card_report.masteur_link"
                label="découvrez Masteur"
            />
        </View>
    )

    const inputContent = (
        <View
            style={{
                width,
                marginBottom: 20,
                paddingHorizontal: 20,
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <TextM
                fontSize={32}
                fontWeight="ExtraBold"
                color={theme.colors.primary}
                style={{
                    textAlign: "center",
                    marginBottom: 20,
                }}
                wrap
            >
                {hasError ? "Une erreur s'est produite" : "Analyse en cours..."}
            </TextM>

            <ChampionImageM
                name="sam"
                variant={hasError ? "unhappy" : "main"}
                width={190}
            />

            <TextM
                fontSize={16}
                fontWeight="regular"
                color={theme.colors.primary}
                style={{
                    marginTop: 20,
                    marginBottom: hasError ? 10 : 20,
                    textAlign: "center",
                }}
                wrap
            >
                {hasError
                    ? "Nous n'avons pas pu envoyer le rapport à cette adresse email."
                    : "Indiquez votre email pour qu'on puisse vous envoyer votre bilan personnalisé"}
            </TextM>

            {hasError && (
                <TextM
                    fontSize={16}
                    fontWeight="regular"
                    color={theme.colors.primary}
                    style={{
                        marginBottom: 20,
                        textAlign: "center",
                    }}
                    wrap
                >
                    {"Veuillez vérifier votre adresse email et réessayer."}
                </TextM>
            )}

            <TextInputM
                placeholder="Entrez votre email"
                keyboardType="email-address"
                control={control}
                name="email"
                errors={errors}
                rules={{
                    required: "Email is required",
                    pattern: {
                        value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                        message: "Enter a valid email address",
                    },
                }}
                contentContainerStyle={{
                    width: "100%",
                }}
                style={{
                    marginBottom: 20,
                }}
            />

            <FilledButtonM
                style={{
                    width: "100%",
                }}
                trackingId="school_card_report.email_submit"
                onPress={handleSubmit(onSubmit)}
                label={hasError ? "Réessayer" : "Recevoir le bilan"}
            />
        </View>
    )

    return (
        <ModalM
            style={{
                justifyContent: "center",
                alignItems: "center",
                width,
            }}
            visible={modalVisible}
            dismissable={false}
            onDismiss={() => {
                setModalVisible(!modalVisible)
            }}
        >
            <ScrollView
                showsVerticalScrollIndicator={false}
                showsHorizontalScrollIndicator={false}
                contentContainerStyle={{
                    flexGrow: 1,
                    paddingTop: 20,
                    alignItems: "center",
                    padding: 20,
                }}
            >
                {emailSubmitted ? successContent : inputContent}
            </ScrollView>
        </ModalM>
    )
}

const mapStateToProps = (state) => ({
    hash: state.data.schoolCardReport?.hash,
})

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    apiRequestWithPrerequest,
}

export default connect(mapStateToProps, mapDispatchToProps)(EnterEmailModal)
